import React, { useEffect, useState } from "react";
import SideBar from "../../components/ThirdPartyDashboard/SideBar";
import Search from "../../components/ThirdPartyDashboard/Search";
import { Link, useNavigate, useParams } from "react-router-dom";
import "../../styles/ThirdParty/Iot.scss";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import moment from "moment";
import { getDataIotForVerifier } from "../../apis/AdminDashboard/users";
import { useSelector } from "react-redux";

function FacilityIot() {
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(false);
  const { plantAddress } = useParams();
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    if (!plantAddress || !auth.token) {
      setDevices([]);
      setLoading(false);
      return;
    }

    let isActive = true;

    const fetchDevices = async () => {
      setLoading(true);
      try {
        const response = await getDataIotForVerifier(plantAddress, auth.token);
        const plants = response?.data?.message?.plants;
        console.log("ver",plants)
        const verifierDevices = Array.isArray(plants)
          ? plants.flatMap((plant) =>
              Array.isArray(plant?.devices) ? plant.devices : [],
            )
          : [];

        if (isActive) setDevices(verifierDevices);
      } catch (error) {
        console.error("Error loading verifier IoT devices:", error);
        if (isActive) setDevices([]);
      } finally {
        if (isActive) setLoading(false);
      }
    };

    fetchDevices();

    return () => {
      isActive = false;
    };
  }, [plantAddress, auth.token]);
  return (
    <div className="iot">
      <div className="sidebar_container">
        <SideBar />
      </div>

      <div className="main">
        <Search />
        <div className="title">IoT Devices</div>

        {loading && (
          <div className="grid">
            {Array.from({ length: 4 }, (_, index) => (
              <div className="card" key={`device-skeleton-${index}`}>
                <div className="grid_inner">
                  <div className="subtitle bold">
                    <Skeleton width={100} height={30} borderRadius={4} />
                  </div>
                  <div>
                    <Skeleton height={30} borderRadius={4} />
                  </div>
                </div>
                <div className="flex">
                  <div className="flex_inner">
                    <Skeleton width={100} height={30} borderRadius={4} />
                  </div>
                  <div className="flex_inner">
                    <Skeleton width={240} height={30} borderRadius={4} />
                  </div>
                </div>
                <div className="more pointer bold">
                  <Skeleton width={100} height={30} borderRadius={4} />
                </div>
              </div>
            ))}
          </div>
        )}

        {!loading && devices.length === 0 && (
          <div className="empty_list">No IoT devices found.</div>
        )}

        {!loading && devices.length > 0 && (
          <div className="grid">
            {devices.map((device, index) => (
              <div
                className="card"
                key={`${device?.id ?? "device"}-${device?.createdAt ?? index}`}
              >
                <div className="grid_inner">
                  {/* <div className="subtitle bold">Name of Organisation:</div> */}
                  {/* <div>CloseCarbon</div> */}
                  <div className="subtitle bold">Sensor ID:</div>
                  <div>{device?.id}</div>
                </div>

                <div className="flex">
                  <div className="flex_inner">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 22.5C9.9233 22.5 7.89323 21.8842 6.16652 20.7304C4.4398 19.5767 3.09399 17.9368 2.29927 16.0182C1.50455 14.0996 1.29661 11.9884 1.70176 9.95156C2.1069 7.91476 3.10693 6.04383 4.57538 4.57538C6.04383 3.10693 7.91476 2.1069 9.95156 1.70176C11.9884 1.29661 14.0996 1.50455 16.0182 2.29927C17.9368 3.09399 19.5767 4.4398 20.7304 6.16652C21.8842 7.89323 22.5 9.9233 22.5 12C22.5 14.7848 21.3938 17.4555 19.4246 19.4246C17.4555 21.3938 14.7848 22.5 12 22.5ZM12 3C10.22 3 8.47992 3.52785 6.99987 4.51678C5.51983 5.50571 4.36628 6.91132 3.68509 8.55585C3.0039 10.2004 2.82567 12.01 3.17294 13.7558C3.5202 15.5016 4.37737 17.1053 5.63604 18.364C6.89472 19.6226 8.49836 20.4798 10.2442 20.8271C11.99 21.1743 13.7996 20.9961 15.4442 20.3149C17.0887 19.6337 18.4943 18.4802 19.4832 17.0001C20.4722 15.5201 21 13.78 21 12C21 9.61306 20.0518 7.32387 18.364 5.63604C16.6761 3.94822 14.387 3 12 3Z"
                        fill="#667185"
                      />
                      <path
                        d="M15.4425 16.5L11.25 12.3075V5.25H12.75V11.685L16.5 15.4425L15.4425 16.5Z"
                        fill="#667185"
                      />
                    </svg>
                    <div>{moment(parseInt(device?.createdAt)).format('hh:mm A')}</div>
                  </div>
                  <div className="flex_inner">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M19.5 3.1875H17.0625V2.25C17.0625 2.10082 17.0032 1.95774 16.8977 1.85225C16.7923 1.74676 16.6492 1.6875 16.5 1.6875C16.3508 1.6875 16.2077 1.74676 16.1023 1.85225C15.9968 1.95774 15.9375 2.10082 15.9375 2.25V3.1875H8.0625V2.25C8.0625 2.10082 8.00324 1.95774 7.89775 1.85225C7.79226 1.74676 7.64918 1.6875 7.5 1.6875C7.35082 1.6875 7.20774 1.74676 7.10225 1.85225C6.99676 1.95774 6.9375 2.10082 6.9375 2.25V3.1875H4.5C4.1519 3.1875 3.81806 3.32578 3.57192 3.57192C3.32578 3.81806 3.1875 4.1519 3.1875 4.5V19.5C3.1875 19.8481 3.32578 20.1819 3.57192 20.4281C3.81806 20.6742 4.1519 20.8125 4.5 20.8125H19.5C19.8481 20.8125 20.1819 20.6742 20.4281 20.4281C20.6742 20.1819 20.8125 19.8481 20.8125 19.5V4.5C20.8125 4.1519 20.6742 3.81806 20.4281 3.57192C20.1819 3.32578 19.8481 3.1875 19.5 3.1875ZM4.5 4.3125H6.9375V5.25C6.9375 5.39918 6.99676 5.54226 7.10225 5.64775C7.20774 5.75324 7.35082 5.8125 7.5 5.8125C7.64918 5.8125 7.79226 5.75324 7.89775 5.64775C8.00324 5.54226 8.0625 5.39918 8.0625 5.25V4.3125H15.9375V5.25C15.9375 5.39918 15.9968 5.54226 16.1023 5.64775C16.2077 5.75324 16.3508 5.8125 16.5 5.8125C16.6492 5.8125 16.7923 5.75324 16.8977 5.64775C17.0032 5.54226 17.0625 5.39918 17.0625 5.25V4.3125H19.5C19.5497 4.3125 19.5974 4.33225 19.6326 4.36742C19.6677 4.40258 19.6875 4.45027 19.6875 4.5V7.6875H4.3125V4.5C4.3125 4.45027 4.33225 4.40258 4.36742 4.36742C4.40258 4.33225 4.45027 4.3125 4.5 4.3125ZM19.5 19.6875H4.5C4.45027 19.6875 4.40258 19.6677 4.36742 19.6326C4.33225 19.5974 4.3125 19.5497 4.3125 19.5V8.8125H19.6875V19.5C19.6875 19.5497 19.6677 19.5974 19.6326 19.6326C19.5974 19.6677 19.5497 19.6875 19.5 19.6875ZM10.3125 11.25V17.25C10.3125 17.3992 10.2532 17.5423 10.1477 17.6477C10.0423 17.7532 9.89918 17.8125 9.75 17.8125C9.60082 17.8125 9.45774 17.7532 9.35225 17.6477C9.24676 17.5423 9.1875 17.3992 9.1875 17.25V12.1603L8.50125 12.5034C8.43514 12.5364 8.36317 12.5561 8.28947 12.5613C8.21576 12.5664 8.14176 12.5571 8.07168 12.5336C8.0016 12.5102 7.93682 12.4732 7.88103 12.4248C7.82525 12.3763 7.77956 12.3174 7.74656 12.2512C7.71357 12.1851 7.69392 12.1132 7.68874 12.0395C7.68355 11.9658 7.69294 11.8918 7.71636 11.8217C7.73977 11.7516 7.77676 11.6868 7.82522 11.631C7.87367 11.5753 7.93264 11.5296 7.99875 11.4966L9.49875 10.7466C9.58452 10.7037 9.67982 10.6836 9.77558 10.6879C9.87135 10.6923 9.96442 10.721 10.0459 10.7715C10.1275 10.8219 10.1948 10.8923 10.2414 10.9761C10.2881 11.0598 10.3125 11.1541 10.3125 11.25ZM15.8972 13.9922L13.875 16.6875H15.75C15.8992 16.6875 16.0423 16.7468 16.1477 16.8523C16.2532 16.9577 16.3125 17.1008 16.3125 17.25C16.3125 17.3992 16.2532 17.5423 16.1477 17.6477C16.0423 17.7532 15.8992 17.8125 15.75 17.8125H12.75C12.6455 17.8125 12.5431 17.7834 12.4543 17.7285C12.3654 17.6736 12.2936 17.595 12.2469 17.5016C12.2002 17.4081 12.1804 17.3035 12.1898 17.1995C12.1992 17.0954 12.2373 16.9961 12.3 16.9125L15 13.3125C15.0777 13.2103 15.1337 13.0933 15.1643 12.9686C15.195 12.844 15.1997 12.7143 15.1782 12.5878C15.1568 12.4612 15.1095 12.3404 15.0394 12.2329C14.9693 12.1253 14.8779 12.0333 14.7708 11.9625C14.6636 11.8918 14.5431 11.8437 14.4167 11.8215C14.2903 11.7992 14.1606 11.8031 14.0358 11.833C13.9109 11.8629 13.7935 11.9181 13.6909 11.9952C13.5882 12.0723 13.5025 12.1697 13.4391 12.2812C13.4055 12.3512 13.3579 12.4134 13.2991 12.4641C13.2404 12.5147 13.1718 12.5527 13.0976 12.5755C13.0235 12.5984 12.9455 12.6056 12.8684 12.5969C12.7913 12.5881 12.7169 12.5635 12.6498 12.5246C12.5827 12.4857 12.5243 12.4334 12.4784 12.3708C12.4325 12.3083 12.4001 12.237 12.3831 12.1613C12.3661 12.0856 12.3649 12.0072 12.3796 11.9311C12.3944 11.8549 12.4247 11.7826 12.4688 11.7188C12.6101 11.4761 12.7996 11.2648 13.0255 11.0979C13.2514 10.931 13.509 10.8121 13.7825 10.7483C14.056 10.6845 14.3397 10.6772 14.6161 10.7269C14.8925 10.7767 15.1559 10.8823 15.39 11.0374C15.6242 11.1926 15.8242 11.3939 15.9777 11.629C16.1313 11.8642 16.2353 12.1282 16.2832 12.4049C16.3311 12.6817 16.322 12.9653 16.2565 13.2384C16.1909 13.5115 16.0702 13.7683 15.9019 13.9931L15.8972 13.9922Z"
                        fill="#667185"
                      />
                    </svg>

                    <div>{moment(parseInt(device?.createdAt)).format('Do MMM YYYY')}</div>
                  </div>
                </div>

                <Link
                  className="more pointer bold"
                    to={`/third-party/iot/${device?.id}/${device?.createdAt}` }
                  
                >
                  View more
                </Link>

                {/* <Tooltip
                title={
                  <Typography variant="h6">
                    {deviceUptimes[device.id]
                      ? "IoT device is active"
                      : "IoT device is experiencing some issues please contact support"}
                  </Typography>
                }
              >
                <div
                  className={
                    deviceUptimes[device.id]
                      ? "card__indicator card__indicator-active"
                      : "card__indicator card__indicator-inactive"
                  }
                ></div>
              </Tooltip> */}

                <div className="card__battery-level">
                  {/* Battery level: <span>{deviceBatteryLevel[device.id]}%</span> */}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default FacilityIot;
